<template>
  <section
    class="component-b94713bb"
    resmed-component-name="card_alt_carousel_3col_icon-line_graphic_text_cta"
    v-bind:style="{
      background: acf.layout['background'],
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="headings text-center">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="'center'"
              ></eyebrow-icon>
              <h5>{{ acf.title }}</h5>
              <h2 v-html="acf.headline"></h2>
              <p class="mb-4" v-html="acf.description"></p>
            </div>
          </div>
        </div>
      </div>

      <div class="swiper container px-xs-sm-2">
        <div class="row">
          <div class="col p-0">
            <div class="seek">
              <div class="seek-wrapper" v-show="sliderControlsVisible">
                <a
                  ref="swiperButtonPrev"
                  href="#"
                  class="btn navigation-icon left-caret swiper-button-prev"
                ></a>
                <a
                  ref="swiperButtonNext"
                  href="#"
                  class="btn navigation-icon right-caret swiper-button-next"
                ></a>
              </div>

              <div
                ref="swiperContainer"
                class="swiper-container"
                v-bind:class="`-mode-${[$root.mode]}`"
              >
                <div class="items swiper-wrapper">
                  <div
                    class="item swiper-slide mb-3 mb-md-0"
                    v-for="(item, index) in acf.products"
                    v-bind:class="{ overflow: overflow && index >= 3 }"
                  >
                    <div class="wrapper">
                      <figure>
                        <img
                          class="img-fluid"
                          v-bind:src="item.image.sizes.large"
                          alt=""
                        />
                        <figcaption
                          v-bind:class="{
                            'text-color-reverse':
                              item['reverse-color'] === 'black',
                          }"
                        >
                          <p class="type" v-if="item.type">{{ item.type }}</p>
                          <h4 v-html="item.title"></h4>
                          <p v-html="item.description"></p>

                          <a
                            v-bind:href="item.href"
                            v-bind:target="item.target[0]"
                            class="btn cta-plain text-red icon right-arrow"
                            >{{ item.cta }}</a
                          >
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-show="sliderControlsVisible">
          <div class="col">
            <div ref="swiperPagination" class="swiper-pagination"></div>
          </div>
        </div>

        <div class="row d-flex d-md-none" v-if="overflow">
          <div class="col text-center mt-3">
            <a
              href="#"
              v-on:click.prevent="overflow = !overflow"
              class="btn cta-pill hallow-red icon move-expand"
              style="margin: 3rem auto 0 auto"
              >Load more</a
            >
          </div>
        </div>

        <div class="row" v-if="acf.cta.href">
          <div class="col text-center mt-3 mt-md-4">
            <a
              v-bind:href="acf.cta.href"
              v-bind:target="acf.cta.target[0]"
              class="btn cta-pill hallow-red icon right-arrow"
              >{{ acf.cta.text }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "component-b94713bb", // card_alt_carousel_3col_icon-line_graphic_text_cta
  props: ["acf"],
  data() {
    return {
      initialized: false,
      slider: undefined,
      overflow: this.acf.products.length > 3,
    };
  },
  mixins: [helper],
  computed: {
    sliderControlsVisible() {
      return this.shouldUseSlider && this.acf.products.length > 3;
    },
    shouldUseSlider() {
      return !["xs", "sm"].includes(this.$root.mode);
    },
  },
  watch: {
    shouldUseSlider(v) {
      if (this.initialized) {
        if (v) {
          this.swhReload();
        } else {
          this.overflow = this.acf.products.length > 3;
          this.swhDestroy();
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.shouldUseSlider) {
        this.swhReload();
      }

      this.initialized = true;
    });
  },
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        // loop: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-b94713bb {
  background-image: linear-gradient(to bottom, #eaf1f8, #c4c9de);
  padding: 5rem 0 4rem 0;
}

.component {
  &.text-color-white {
    h5 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h2 {
    margin-bottom: 1.5rem;
  }

  h4 {
    margin-bottom: 0.325rem;
    color: $cc-resmed-white;
  }

  h5 {
    position: relative;
    margin-bottom: 0.75rem;

    @extend %eyebrow-center;
  }

  .item {
    padding: 0 0.625rem;

    p {
      color: $cc-resmed-white;

      &.type {
        @extend %body-small;
        margin-bottom: 1rem;
      }
    }

    > div {
      display: flex;
      box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
      background-color: $cc-resmed-white;
      border-radius: 6px;
      overflow: hidden;
    }

    .embed-responsive-item {
      border-radius: 6px;
      overflow: hidden;
    }

    figure {
      display: flex;
      flex-direction: column;
      width: 100%;

      img {
        align-self: center;
      }

      figcaption {
        position: relative;
        background-color: $cc-resmed-white;
        padding: 2rem 2rem 4rem 2rem;
        flex-grow: 1;

        a {
          position: absolute;
          bottom: 2rem;
          left: 2rem;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .overflow {
      display: none;
    }
  }

  @media (max-width: 991px) {
    .swiper {
      max-width: none;
      width: 90vw !important;
    }
  }

  .text-color-reverse {
    h4,
    p {
      color: $cc-resmed-black;
    }
  }

  .seek-wrapper {
    position: absolute;
    z-index: 1;

    width: 30%;
    bottom: -42px;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 992px) {
      width: 20%;
    }

    @media (min-width: 1306px) {
      width: 100%;
      bottom: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    a:nth-child(1) {
      float: left;
      transform: translateX(-4rem) scale(1.4);
    }

    a:nth-child(2) {
      float: right;
      transform: translateX(4rem) scale(1.4);
    }
  }

  .-mode-md,
  .-mode-lg,
  .-mode-xl {
    &.swiper-container {
      position: relative;
      width: 100%;
      height: 100%;

      overflow: hidden;
      padding: 1rem 0 2rem 0;
      margin: 0 auto;
      z-index: 1;
    }

    .items {
      display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    .item {
      display: flex;
      flex-shrink: 0;
      align-items: stretch;

      padding: 0 0.725rem;
      width: 33.33%;
    }
  }
}
</style>